import { useContext, createContext } from 'react';

import type { AnnotationsActionsHandler } from '../types/annotations.js';

export const AnnotationsActionsContext = createContext<
  AnnotationsActionsHandler | undefined
>(undefined);

export const useSeriesActions = () => useContext(AnnotationsActionsContext);

AnnotationsActionsContext['displayName'] = 'AnnotationsActionsContext';
